import { render, staticRenderFns } from "./ProductLabelCard.vue?vue&type=template&id=20bbc9d4&scoped=true"
import script from "./ProductLabelCard.vue?vue&type=script&lang=js"
export * from "./ProductLabelCard.vue?vue&type=script&lang=js"
import style0 from "./ProductLabelCard.vue?vue&type=style&index=0&id=20bbc9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbc9d4",
  null
  
)

export default component.exports